module.exports = __webpack_public_path__ + "img/logo.d0289dc0.png";